<template lang="pug">
.main-content
  .form-group
    label.col-md-12 品名
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.productName')
  .form-group
    label.col-md-12 品名備考
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.productName_ext')
  .form-group
    label.col-md-12 形式
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.format')
  .form-group
    label.col-md-12 形式備考
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.format_ext')
  .form-group
    label.col-md-12 駆動方式
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.driveSystem')
  .form-group
    label.col-md-12 駆動方式備考
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.driveSystem_ext')
  .form-group
    label.col-md-12 駆動軸数
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.axis')
  .form-group
    label.col-md-12 駆動軸数備考
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.axis_ext')
  .form-group
    label.col-md-12  可搬重量
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.payload.spec')
    label.col-md-12  可搬重量備考
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.payload.remarks')
  .form-group
    label.col-md-12  アーム長
    .col-md-12
      label.col-md-12 全長
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.armLength.fullLength')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.armLength.fullLength_ext')
      label.col-md-12.mt-3 第1アーム
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.armLength.firstLength')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.armLength.firstLength_ext')
      label.col-md-12.mt-3 第2アーム
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.armLength.secondLength')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.armLength.secondLength_ext')
  .form-group
    label.col-md-12  動作範囲
    .col-md-12
      label.col-md-12 第1軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.operatingRange.firstAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.operatingRange.firstAxis_ext')
      label.col-md-12.mt-3 第2軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.operatingRange.secondAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.operatingRange.secondAxis_ext')
      label.col-md-12.mt-3 第3軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.operatingRange.thirdAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.operatingRange.thirdAxis_ext')
      label.col-md-12.mt-3 第4軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.operatingRange.fourthAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.operatingRange.fourthAxis_ext')
  .form-group
    label.col-md-12  動作速度
    .col-md-12
      label.col-md-12 第1軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.movingSpeed.firstAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.movingSpeed.firstAxis_ext')
      label.col-md-12.mt-3 第2軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.movingSpeed.secondAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.movingSpeed.secondAxis_ext')
      label.col-md-12.mt-3 第3軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.movingSpeed.thirdAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.movingSpeed.thirdAxis_ext')
      label.col-md-12.mt-3 第4軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.movingSpeed.fourthAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.movingSpeed.fourthAxis_ext')
  .form-group
    label.col-md-12  モータ容量
    .col-md-12
      label.col-md-12 第1軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.motersCapacity.firstAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.motersCapacity.firstAxis_ext')
      label.col-md-12.mt-3 第2軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.motersCapacity.secondAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.motersCapacity.secondAxis_ext')
      label.col-md-12.mt-3 第3軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.motersCapacity.thirdAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.motersCapacity.thirdAxis_ext')
      label.col-md-12.mt-3 第4軸
      .col-md-12
        el-input(type='text',value='', v-model='coSwanData.motersCapacity.fourthAxis')
        label 備考
          el-input(type='text',value='', v-model='coSwanData.motersCapacity.fourthAxis_ext')
  .form-group
    label.col-md-12 位置繰り返し速度
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.accuracy2')
      label 備考
        el-input(type='text',value='', v-model='coSwanData.accuracy2_ext')
  .form-group
    label.col-md-12 質量
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.mass')
      label 備考
        el-input(type='text',value='', v-model='coSwanData.mass_ext')
  .form-group
    label.col-md-12 電源容量
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.powerSupply')
      label 備考
        el-input(type='text',value='', v-model='coSwanData.powerSupply_ext')
  .form-group
    label.col-md-12 塗装色(ボディ)
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.paintColor[0].body')
    label.col-md-12  備考
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.paintColor[1].body')
  .form-group
    label.col-md-12 塗装色(ベース)
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.paintColor[0].base')
    label.col-md-12  備考
    .col-md-12
      el-input(type='text',value='', v-model='coSwanData.paintColor[1].base')
  .form-group
    span.col-md-12 画像:正面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("frontImageFileAdd")'
    )
    .col-md-12
      el-table(:data='coSwanData.frontImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "frontImage")') 
      input#frontImageFileAdd.hidden(type='file', @change='onFileAdd($event, "frontImage")', accept='image/*')
  .form-group
    span.col-md-12 画像:側面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("sideImageFileAdd")'
    )
    .col-md-12
      el-table(:data='coSwanData.sideImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "sideImage")') 
      input#sideImageFileAdd.hidden(type='file', @change='onFileAdd($event, "sideImage")', accept='image/*')
  .form-group
    span.col-md-12 画像:上面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("topImageFileAdd")'
    )
    .col-md-12
      el-table(:data='coSwanData.topImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "topImage")') 
      input#topImageFileAdd.hidden(type='file', @change='onFileAdd($event, "topImage")', accept='image/*')
</template>

<script>
export default {
  name: 'CoSwan',
  data () {
    return {
    }
  },
  props: {
    coSwanData: Object
  },
  created () {
    if (!this.coSwanData.frontImage) {
      this.coSwanData.frontImage = []
    }
    if (!this.coSwanData.sideImage) {
      this.coSwanData.sideImage = []
    }
    if (!this.coSwanData.topImage) {
      this.coSwanData.topImage = []
    }
  },
  methods: {
    deleteImage (index, imageType) {
      let imageName = ''
      let imageObject
      if (imageType === 'frontImage') {
        imageName = this.coSwanData.frontImage[index].name !== undefined ? this.coSwanData.frontImage[index].name : '画像'
        imageObject = this.controlPanelData.frontImage
      } else if (imageType === 'sideImage') {
        imageName = this.coSwanData.sideImage[index].name !== undefined ? this.coSwanData.sideImage[index].name : '画像'
        imageObject = this.controlPanelData.sideImage
      } else if (imageType === 'topImage') {
        imageName = this.coSwanData.topImage[index].name !== undefined ? this.coSwanData.topImage[index].name : '画像'
        imageObject = this.coSwanData.topImage
      }
      this.$confirm(imageName + 'を削除しますか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        imageObject.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    onBtnFileAdd (idName) {
      document.getElementById(idName).click()
    },
    onFileAdd (event, objName) {
      let files = event.target.files || event.dataTransfer.files
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.coSwanData[objName].splice(0, 1)
          this.coSwanData[objName].push({ name: files[0].name, image: r.target.result, caption: '' })
        }
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    }
  }
}
</script>

<style lang="scss", scoped>
.hidden {
  visibility: hidden;
}

*:focus {
  outline: 0
}
</style>



// WEBPACK FOOTER //
// src/views/components/swan/techInfo/CoSwan.vue